var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 44.9998,
    r: 45,
    fill: "#209AA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1459 18H33.8541L30 21H61L57.1459 18Z",
    fill: "#68CEE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18H34.1455L30 21H36.2491L38 18Z",
    fill: "#41A3B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5321 21H61L57.3727 18H54L55.5321 21Z",
    fill: "#91DBED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 72H67V22H24V72Z",
    fill: "#F5D371"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 72H24V22H26V72Z",
    fill: "#CAAA59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72H67V22H65V72Z",
    fill: "#FCE591"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23H24V22H67V23Z",
    fill: "#D7BB67"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23H24V22H26V23Z",
    fill: "#AA8F51"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23H65V22H67V23Z",
    fill: "#F5D371"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19H24V22H67V19Z",
    fill: "#F5D371"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19H65V22H67V19Z",
    fill: "#FCE591"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19H24V22H26V19Z",
    fill: "#CAAA59"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32H36V29H28V32Z",
    fill: "#CAAA59"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32H35V30H28V32Z",
    fill: "#68CEE5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39H36V36H28V39Z",
    fill: "#CAAA59"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38H35V36H28V38Z",
    fill: "#68CEE5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28 45H36V42H28V45Z",
    fill: "#CAAA59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28 45H35V42H28V45Z",
    fill: "#68CEE5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4336 31.9382H35.4578V29.6907H28.4336V31.9382Z",
    fill: "#81D6E8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3351 38H32.9032L35 36.9191V37.6571L34.3351 38ZM30.7079 38H29.9782L33.8577 36H34.5877L30.7079 38ZM28 37.8976V37.5211L30.9509 36H31.6807L28 37.8976Z",
    fill: "#81D6E8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9803 45H33.2506L35 43.6474V44.2119L33.9803 45ZM31.0058 45H29.5739L33.4537 42H34.8853L31.0058 45ZM28.6616 45H28V43.3335L29.7245 42H32.5414L28.6616 45Z",
    fill: "#81D6E8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32H45V29H37V32Z",
    fill: "#CAAA59"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32H44V30H37V32Z",
    fill: "#68CEE5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37 39H45V36H37V39Z",
    fill: "#CAAA59"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38H44V36H37V38Z",
    fill: "#68CEE5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45H45V42H37V45Z",
    fill: "#CAAA59"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45H44V42H37V45Z",
    fill: "#68CEE5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3657 38H42L44 37V37.6828L43.3657 38Z",
    fill: "#81D6E8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8774 38H39.1019L43.2246 36H44L39.8774 38ZM37 37.8976V37.5211L40.1356 36H40.9114L37 37.8976Z",
    fill: "#81D6E8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7628 32H40L44 30V30.3814L40.7628 32Z",
    fill: "#81D6E8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0409 32H37V31.7877L40.5387 30H42L38.0409 32ZM37 31.3864V30.6484L38.2835 30H39.7448L37 31.3864Z",
    fill: "#81D6E8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M42.981 45H42.2508L44 43.6474V44.2119L42.981 45ZM40.0059 45H38.5743L42.454 42H43.886L40.0059 45ZM37.662 45H37V43.3335L38.7249 42H41.5417L37.662 45Z",
    fill: "#81D6E8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55H36V52H28V55Z",
    fill: "#CAAA59"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55H35V52H28V55Z",
    fill: "#68CEE5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61H36V59H28V61Z",
    fill: "#CAAA59"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61H35V59H28V61Z",
    fill: "#68CEE5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28 68H36V65H28V68Z",
    fill: "#CAAA59"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28 67H35V65H28V67Z",
    fill: "#68CEE5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3658 61H33L35 60V60.6828L34.3658 61Z",
    fill: "#81D6E8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8774 61H30.1019L34.2242 59H35L30.8774 61ZM28 60.8976V60.5212L31.1356 59H31.911L28 60.8976Z",
    fill: "#81D6E8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.572 55H32L35 53V53.3814L32.572 55Z",
    fill: "#81D6E8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0406 55H28V54.6812L31.5391 52H33L29.0406 55ZM28 54.0797V52.9724L29.2835 52H30.7448L28 54.0797Z",
    fill: "#81D6E8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9803 67H33.2506L35 66.0981V66.4745L33.9803 67ZM31.0058 67H29.5739L33.4537 65H34.8853L31.0058 67ZM28.6616 67H28V65.8891L29.7245 65H32.5414L28.6616 67Z",
    fill: "#81D6E8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55H45V52H37V55Z",
    fill: "#CAAA59"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55H44V52H37V55Z",
    fill: "#68CEE5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M37 61H45V59H37V61Z",
    fill: "#CAAA59"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M37 61H44V59H37V61Z",
    fill: "#68CEE5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37 68H45V65H37V68Z",
    fill: "#CAAA59"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67H44V65H37V67Z",
    fill: "#68CEE5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3657 61H42L44 60V60.6828L43.3657 61Z",
    fill: "#81D6E8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8774 61H39.1019L43.2246 59H44L39.8774 61ZM37 60.8976V60.5212L40.1356 59H40.9114L37 60.8976Z",
    fill: "#81D6E8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7628 55H40L44 53V53.3814L40.7628 55Z",
    fill: "#81D6E8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0409 55H37V54.6812L40.5387 52H42L38.0409 55ZM37 54.0797V52.9724L38.2835 52H39.7448L37 54.0797Z",
    fill: "#81D6E8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M42.981 67H42.2508L44 66.0981V66.4745L42.981 67ZM40.0059 67H38.5743L42.454 65H43.886L40.0059 67ZM37.662 67H37V65.8891L38.7249 65H41.5417L37.662 67Z",
    fill: "#81D6E8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M46 72H70V27H46V72Z",
    fill: "#68CEE5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0959 72H57.6891L70 64.7452V65.5741L59.0959 72ZM54.7934 72H53.3866L70 62.2101V63.0389L54.7934 72ZM52.2984 72H47.207L70 58.5682V61.5688L52.2984 72ZM46 70.5545V69.7257L70 55.5829V56.4118L46 70.5545ZM46 65.8686V65.0397L70 50.8967V51.7255L46 65.8686ZM46 58.3806V55.3801L70 41.2373V44.2376L46 58.3806ZM46 54.5552V53.7264L70 39.5833V40.4122L46 54.5552ZM46 47.5606V46.7318L69.6485 32.7959L70 33.4176L46 47.5606ZM46 43.2418V42.413L70 28.2699V29.0988L46 43.2418ZM46 40.3465V37.3459L63.5567 27H68.6484L46 40.3465ZM46 35.7839V34.955L59.499 27H60.9057L46 35.7839ZM46 31.9288V31.0996L52.9567 27H54.3635L46 31.9288Z",
    fill: "#81D6E8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72H46V27H47V72Z",
    fill: "#41A3B7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72H69V27H70V72Z",
    fill: "#91DBED"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48 72H47V27H48V72Z",
    fill: "#91DBED"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72H64V27H65V72Z",
    fill: "#91DBED"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72H64V27H65V72Z",
    fill: "#41A3B7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35H47V34H69V35Z",
    fill: "#91DBED"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M69 57H47V56H69V57Z",
    fill: "#41A3B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.eb18f874e195fc2a2d2f72892cced850.svg";
export { ForwardRef as ReactComponent };